export const keyboardLetters = [
  ['Q', 'W', 'E', 'R', 'T', 'Y', 'U', 'I', 'O', 'P'],
  ['A', 'S', 'D', 'F', 'G', 'H', 'J', 'K', 'L'],
  ['Z', 'X', 'C', 'V', 'B', 'N', 'M'],
]

export const letters = [
  'A',
  'Á',
  'B',
  'C',
  'D',
  'Ð',
  'E',
  'É',
  'F',
  'G',
  'H',
  'I',
  'Í',
  'J',
  'K',
  'L',
  'M',
  'N',
  'O',
  'Ó',
  'P',
  'Q',
  'R',
  'S',
  'T',
  'U',
  'Ú',
  'V',
  'W',
  'X',
  'Y',
  'Ý',
  'Z',
  'Þ',
  'Æ',
  'Ö',
]
/*

['Á','É','Í','Ú','Ý'],
  ['Q', 'W', 'E', 'R', 'T', 'Y', 'U', 'I', 'O', 'P','Ð'],
  ['A', 'S', 'D', 'F', 'G', 'H', 'J', 'K', 'L', 'Æ'],
  ['Z', 'X', 'C', 'V', 'B', 'N', 'M', 'Þ'],

  
export const keyboardLetters = [
  ['Q', 'W', 'E', 'É', 'R', 'T', 'Y', 'U', 'I' ,'Í', 'O', 'Ó', 'P', 'Ð', 'Ö'],
  ['A', 'Á', 'S', 'D', 'F', 'G', 'H', 'J', 'K', 'L', 'Æ'],
  ['Z', 'X', 'C', 'V', 'B', 'N', 'M', 'Þ'],
]

export const letters = [
  'A',
  'Á',
  'B',
  'C',
  'D',
  'Ð',
  'E',
  'É',
  'F',
  'G',
  'H',
  'I',
  'Í',
  'J',
  'K',
  'L',
  'M',
  'N',
  'O',
  'Ó',
  'P',
  'Q',
  'R',
  'S',
  'T',
  'U',
  'Ú',
  'V',
  'W',
  'X',
  'Y',
  'Z',
  'þ',
  'Æ',
  'Ö',
]
*/
export const status = {
  green: 'green',
  yellow: 'yellow',
  gray: 'gray',
  unguessed: 'unguessed',
}
